import { useFormikContext } from 'formik';
import React from 'react';

import { AutocompleteField } from '@components/FormFields';
import DropdownField from '@components/FormFields/DropdownField';
import { useEntitiesCreate } from '@hooks';
import { autocompleteEntities } from '@utils/backend-api/entities';
import {
  ENTITY_TYPE_ORGANIZATION_INDUSTRY,
  ENTITY_WORD_TYPE_COMMON,
  ORGANIZATION_INDUSTRY_OPTIONS,
  PROFILE_FIELD_OTHER_VALUE,
} from '@utils/backend-api/profileSettings';

import { StepProfileFormProps } from '../StepProfile';

const IndustryFields = () => {
  const { values } = useFormikContext<StepProfileFormProps>();
  const { mutateAsync: createEntityAsync } = useEntitiesCreate();
  return (
    <>
      <DropdownField
        name="industry"
        options={ORGANIZATION_INDUSTRY_OPTIONS}
        label="Industry&#42;"
        placeholder="Select"
        isClearable={false}
      />
      {values.industry.value === PROFILE_FIELD_OTHER_VALUE && (
        <AutocompleteField
          name="customIndustry"
          fetchMethod={(value) =>
            autocompleteEntities({
              fragment: value,
              entity_type: ENTITY_TYPE_ORGANIZATION_INDUSTRY,
            })
          }
          createMethod={(value) =>
            createEntityAsync({
              name: value,
              entity_type: ENTITY_TYPE_ORGANIZATION_INDUSTRY,
              word_type: ENTITY_WORD_TYPE_COMMON,
            })
          }
        />
      )}
    </>
  );
};

export default IndustryFields;
